import type { AcquisitionVsCurrentDto } from "../../models/Dashboard";
import "./DashboardStyleSheet.css";

const AcquisitionVsCurrentCard: React.FC<{
    items: AcquisitionVsCurrentDto[]
}> = ({ items }) => (
    <div className="dashboard-card">
        <div className="dashboard-card-header">
            <h2>Acquisition vs Current Value</h2>
        </div>
        <div className="dashboard-card-body">
            <table className="data-table">
                <thead>
                    <tr>
                        <th>Work</th>
                        <th className="text-right">Acquired</th>
                        <th className="text-right">Current</th>
                        <th className="text-right">Gain / Loss</th>
                        <th className="text-right">%</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map(item => (
                        <tr key={item.artworkId}>
                            <td>
                                <div className="cell-title">{item.title}</div>
                                <div className="cell-sub">{item.artistName}</div>
                            </td>
                            <td className="text-right">{item.acquisitionFormatted}</td>
                            <td className="text-right">{item.currentFormatted}</td>
                            <td className={`text-right gain-loss--${item.direction}`}>
                                {item.gainLossFormatted}
                            </td>
                            <td className={`text-right gain-loss--${item.direction}`}>
                                {item.gainLossPct.toFixed(1)}%
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
    );

export default AcquisitionVsCurrentCard;
